/**
 * @generated SignedSource<<43d7c84cecf9352ec462649de136671e>>
 * @relayHash bc3b9c853498ea50bed953195f153e46
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b67c61b0396ec451660f0e2ffb486e63e6b02606d10d3ba3df4cec14bb8668e7

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type HelpCenterPageCreateInput = {
  clonePageAri?: string | null | undefined;
  description?: string | null | undefined;
  helpCenterAri: string;
  name: string;
  pageLayout?: HelpCenterPageLayoutInput | null | undefined;
};
export type HelpCenterPageLayoutInput = {
  layoutAdf?: string | null | undefined;
  metadata?: string | null | undefined;
};
export type mainHubCreateMutation$variables = {
  cloudId: string;
  connections: ReadonlyArray<string>;
  input: HelpCenterPageCreateInput;
};
export type mainHubCreateMutation$data = {
  readonly helpCenter: {
    readonly createHelpCenterPage: {
      readonly errors: ReadonlyArray<{
        readonly extensions: {
          readonly statusCode: number | null | undefined;
        } | null | undefined;
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly helpCenterPage: {
        readonly description: {
          readonly default: string | null | undefined;
        } | null | undefined;
        readonly helpCenterAri: string;
        readonly id: string;
        readonly name: {
          readonly default: string;
        } | null | undefined;
        readonly updatedAt: string | null | undefined;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type mainHubCreateMutation = {
  response: mainHubCreateMutation$data;
  variables: mainHubCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v3 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "success"
},
v6 = {
  "kind": "ScalarField",
  "name": "message"
},
v7 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v8 = {
  "kind": "ScalarField",
  "name": "id"
},
v9 = [
  {
    "kind": "ScalarField",
    "name": "default"
  }
],
v10 = {
  "concreteType": "HelpCenterPage",
  "kind": "LinkedField",
  "name": "helpCenterPage",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    {
      "concreteType": "HelpCenterPageName",
      "kind": "LinkedField",
      "name": "name",
      "plural": false,
      "selections": (v9/*: any*/)
    },
    {
      "concreteType": "HelpCenterPageDescription",
      "kind": "LinkedField",
      "name": "description",
      "plural": false,
      "selections": (v9/*: any*/)
    },
    {
      "kind": "ScalarField",
      "name": "helpCenterAri"
    },
    {
      "kind": "ScalarField",
      "name": "updatedAt"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "mainHubCreateMutation",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "HelpCenterMutationApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": (v4/*: any*/),
            "concreteType": "HelpCenterPageCreatePayload",
            "kind": "LinkedField",
            "name": "createHelpCenterPage",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v6/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/)
                    ]
                  }
                ]
              },
              (v10/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "mainHubCreateMutation",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "HelpCenterMutationApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": (v4/*: any*/),
            "concreteType": "HelpCenterPageCreatePayload",
            "kind": "LinkedField",
            "name": "createHelpCenterPage",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v6/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      (v7/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v8/*: any*/)
                        ],
                        "type": "BulkMutationErrorExtension"
                      }
                    ]
                  }
                ]
              },
              (v10/*: any*/),
              {
                "handle": "appendNode",
                "key": "",
                "kind": "LinkedHandle",
                "name": "helpCenterPage",
                "handleArgs": [
                  {
                    "kind": "Variable",
                    "name": "connections",
                    "variableName": "connections"
                  },
                  {
                    "kind": "Literal",
                    "name": "edgeTypeName",
                    "value": "HelpCenterPageQueryResultEdge"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "b67c61b0396ec451660f0e2ffb486e63e6b02606d10d3ba3df4cec14bb8668e7",
    "metadata": {},
    "name": "mainHubCreateMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "66820526aa19200e7113aa80119d7181";

export default node;
